export default __webpack_public_path__ + "assets/takeaway-delivery.f4a07552.svg";